export default __webpack_public_path__ + "static/media/template-address.4e4d03ef.xlsx";